import { AfterContentInit, Component, ContentChildren, DestroyRef, QueryList, inject, input } from '@angular/core';
import { FieldFillerComponent } from '../field-types/field-filler.component';
import { FieldFieldComponent } from '../field-types/field-field.component';
import { delay } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'r1-compass-lib-field-row',
    template: `
        <div class="mapper-row" [style.gap]="flexGapSize()">
            <ng-content />
        </div>
    `,
    // For the moment, commented out this:
    // flex-wrap: wrap;
    styles: [
        `
            .mapper-row {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
            }
        `,
    ],
})
export class FieldRowComponent implements AfterContentInit {
    // TODO - require
    fieldRowWidth = input<number>(1);
    // TODO - Commented out `.mapper-row { flex-wrap: wrap }` as it seemed more trouble than it was worth
    //        aka "Division > Data Mapping >Addiitonal Fields (9411)" couldn't fit 4/4 content
    //        but other ones look fine. The screen sizes where wrapping helps seems to be a bit low.
    //        Whoever is reviewing, bring this up and give your take on it to Michael who will show the difference.
    flexGapSize = input<string>('20px');

    destroyed$ = inject(DestroyRef);

    @ContentChildren(FieldFieldComponent) singleFields!: QueryList<FieldFieldComponent>;
    @ContentChildren(FieldFillerComponent) fieldFiller!: QueryList<FieldFillerComponent>;

    ngAfterContentInit() {
        // This is a bit of a hack
        // https://stackoverflow.com/questions/55286309/changing-contentchildren-models-on-querylist-changes
        setTimeout(() => {
            this.setSingleFieldWidths();
            this.setFieldFillerWidths();

            this.singleFields.changes.pipe(delay(0), takeUntilDestroyed(this.destroyed$)).subscribe(() => {
                this.setSingleFieldWidths();
            });

            this.fieldFiller.changes.pipe(delay(0), takeUntilDestroyed(this.destroyed$)).subscribe(() => {
                this.setFieldFillerWidths();
            });
        }, 0);
    }

    private setSingleFieldWidths() {
        this.singleFields.forEach((field: FieldFieldComponent) => {
            field.setWidthPer(this.setGroupingRows(this.fieldRowWidth(), field.fieldWidth(), this.flexGapSize()));
        });
    }

    private setFieldFillerWidths() {
        this.fieldFiller.forEach((filler: FieldFillerComponent) => {
            filler.setWidthPer(this.setGroupingRows(this.fieldRowWidth(), filler.fieldWidth(), this.flexGapSize()));
        });
    }

    /**
     * Sets proportionate percentage width of the row,
     * with consideration of the flex container's `gap` property's # pixels
     */
    private setGroupingRows(fractionOfFullRowWidth: number, singleFieldWidth: number, flexGapSize: string) {
        const fraction = singleFieldWidth / fractionOfFullRowWidth;
        const fractionAsPercent = Math.floor(fraction * 100);
        return `calc(${fractionAsPercent}% - ${flexGapSize})`;
    }
}
